(function() {
  if (window.irShippingDetectionDone) return;
  window.irShippingDetectionDone = true;

  const CACHE_KEY = 'ir_geo_country';
  const CACHE_DURATION = 3600000;

  function getCache() {
    try {
      const cached = localStorage.getItem(CACHE_KEY);
      if (cached) {
        const data = JSON.parse(cached);
        if (Date.now() - data.timestamp < CACHE_DURATION) {
          return data.country;
        }
      }
    } catch (e) {}
    return null;
  }

  function setCache(country) {
    try {
      localStorage.setItem(CACHE_KEY, JSON.stringify({
        country: country,
        timestamp: Date.now()
      }));
    } catch (e) {}
  }

  function applyCountry(country) {
    window.irShippingCountry = country;
    document.body.classList.remove('ir-international', 'ir-domestic');
    document.body.classList.add(country === 'US' ? 'ir-domestic' : 'ir-international');
    
    const domestic = document.getElementById('cart-shipping-domestic');
    const international = document.getElementById('cart-shipping-international');
    
    if (domestic && international) {
      domestic.classList.toggle('is-visible', country === 'US');
      international.classList.toggle('is-visible', country !== 'US');
      domestic.setAttribute('aria-hidden', country !== 'US');
      international.setAttribute('aria-hidden', country === 'US');
    }
  }

  const GEO_API_URL = 'https://vercel-geo-api-xi.vercel.app/api/is-non-ca-state';

  function detectCountry() {
    const timeout = setTimeout(function() {
      applyCountry('US');
    }, 2000);

    fetch(GEO_API_URL)
      .then(function(r) {
        clearTimeout(timeout);
        if (!r.ok) throw new Error();
        return r.json();
      })
      .then(function(data) {
        const country = (data.country && String(data.country).toUpperCase()) || 'US';
        setCache(country);
        applyCountry(country);
      })
      .catch(function() {
        clearTimeout(timeout);
        applyCountry('US');
      });
  }

  const cached = getCache();
  if (cached) {
    applyCountry(cached);
  } else {
    detectCountry();
  }

  window.irCartShippingApplyCountry = function() {
    const country = window.irShippingCountry || 'US';
    applyCountry(country);
  };
})();

(function() {
  var CONFIG = {
    cutoffHour: 14,
    timezone: 'America/Chicago'
  };

  function updateShippingTime() {
    var now = new Date();
    var centralTime;

    try {
      centralTime = new Date(now.toLocaleString('en-US', { timeZone: CONFIG.timezone }));
    } catch (e) {
      centralTime = now;
    }

    var dayOfWeek = centralTime.getDay();
    var hours = centralTime.getHours();
    var minutes = centralTime.getMinutes();
    var currentTimeInMinutes = hours * 60 + minutes;
    var cutoffTimeInMinutes = CONFIG.cutoffHour * 60;
    var message = '';

    if (dayOfWeek === 0 || dayOfWeek === 6) {
      message = 'Ships out Monday morning';
    } else if (dayOfWeek === 5 && currentTimeInMinutes >= cutoffTimeInMinutes) {
      message = 'Ships out Monday morning';
    } else if (currentTimeInMinutes < cutoffTimeInMinutes) {
      var minutesRemaining = cutoffTimeInMinutes - currentTimeInMinutes;
      var hoursRemaining = Math.floor(minutesRemaining / 60);
      if (hoursRemaining < 1) {
        message = 'Order in next ' + minutesRemaining + ' minutes to ship today';
      } else {
        message = 'Order in next ' + hoursRemaining + ' hour' + (hoursRemaining > 1 ? 's' : '') + ' to ship today';
      }
    } else {
      message = 'Ships out tomorrow morning';
    }

    document.querySelectorAll('#shipping-time-text, .js-shipping-time').forEach(function(el) {
      el.textContent = message;
    });
  }

  function initShippingTimer() {
    if (window.irShippingCountry === 'US') {
      updateShippingTime();
      if (!window.irShippingTimerStarted) {
        window.irShippingTimerStarted = true;
        setInterval(updateShippingTime, 60000);
      }
    }
  }

  if (window.irShippingCountry) {
    initShippingTimer();
  } else {
    var checkInterval = setInterval(function() {
      if (window.irShippingCountry) {
        clearInterval(checkInterval);
        initShippingTimer();
      }
    }, 100);
    setTimeout(function() { clearInterval(checkInterval); }, 5000);
  }
})();
